import React, { Fragment, useEffect, useState } from "react";
import { EditeMoney, GetData } from "./Components/Services";
import CommonFrom from "../../../Common/Components/Form";
import Loading from "../../../Common/Components/Loading";
import toast from "react-hot-toast";

function Edite(props) {
  const initialState = {
    loading: false,
  };

  const [state, setstate] = useState(initialState);

  useEffect(() => {
    getdata();
    toast("شماره شبا بدون حروف اول وارد شود", {
      duration: 7000,
    });
  }, []);

  const getdata = () => {
    setstate({ ...state, loading: true });
    GetData().then(result => {
      setstate({
        loading: false,
        gdata: result,
      });
    });
  };
  const Handler = data => {
    setstate({ loading: true });
    EditeMoney(data).then(() => {
      getdata();
    });
  };

  let input = [
    {
      label: "نام بانک",
      size: "col-md-3",
      classNames: "mt-2",
      placeholder: "",
      name: "bank_name",
      type: "text",
    },
    {
      label: "شماره کارت بانکی",
      size: "col-md-9",
      classNames: "mt-2",
      placeholder: "",
      name: "bank_number",
      type: "number",
    },
    {
      label: "شماره شبا بانکی",
      size: "col-md-12",
      classNames: "mt-2",
      placeholder: "",
      name: "shaba_number",
      type: "number",
    },
  ];

  return (
    <Fragment>
      {state.loading ? (
        <Loading count={1} col={12} height={400} />
      ) : (
        <CommonFrom
          form={input}
          loading={false}
          header="اطلاعات مالی"
          btnName="ثبت اطلاعات"
          submit={Handler}
          value={state.gdata}
          edit={true}
        />
      )}
    </Fragment>
  );
}

export default Edite;
